(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo-2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veira-logo-motion')) {
    class VeiraLogoMotion extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.frame = 0;
        this.compact = false;
        if (!this.hasAttribute('data-enabled')) return;
        this.threshold = Math.max(20, Number(this.dataset.threshold) || 100);
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        // Scroll does not bubble: capture catches nested desktop scroll containers.
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true, signal: this.controller.signal });
        window.addEventListener('scroll', this.onScroll, { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', this.onScroll, { passive: true, signal: this.controller.signal });
        window.addEventListener('pageshow', this.onScroll, { signal: this.controller.signal });
        this.update();
      }
      update() {
        let scroll = Math.max(0, window.scrollY || 0, document.scrollingElement?.scrollTop || 0);
        // The theme scrolls .page-wrapper on desktop, not always window.
        for (let parent = this.parentElement; parent; parent = parent.parentElement) {
          if (parent.scrollHeight > parent.clientHeight + 1 && /^(auto|scroll|overlay)$/.test(getComputedStyle(parent).overflowY)) {
            scroll = Math.max(scroll, parent.scrollTop || 0);
          }
        }
        // Hysteresis prevents flickering around the transition point.
        this.compact = this.compact ? scroll > this.threshold - 16 : scroll >= this.threshold;
        this.toggleAttribute('data-compact', this.compact);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    }
    customElements.define('veira-logo-motion', VeiraLogoMotion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('veira-product-viewer-v4')){
 customElements.define('veira-product-viewer-v4',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.observer?.disconnect();this.controller=new AbortController();const signal=this.controller.signal;
   this.dialog=this.querySelector('dialog');this.stage=this.querySelector('.vzoom-stage');this.img=this.querySelector('.vzoom-image');
   try{this.images=JSON.parse(this.querySelector('[data-vzoom-images]').textContent);}catch{this.images=[];}
   if(!this.images.length)return;
   this.scale=1;this.x=0;this.y=0;this.index=0;this.points=new Map();
   const layout=this.closest('veira-media-layout');
   layout.addEventListener('click',event=>{
    if(this.contains(event.target)||event.defaultPrevented)return;
    const container=event.target.closest('.product-media-container--image');if(!container)return;
    let index=-1;
    const indexed=event.target.closest('[data-veira-viewer-index]')||container;
    if(indexed.dataset.veiraViewerIndex!==undefined)index=this.images.findIndex(image=>image.index===Number(indexed.dataset.veiraViewerIndex));
    const trigger=event.target.closest('button')||container;
    const action=trigger.getAttribute('on:click')||container.getAttribute('on:click')||'';
    const matched=action.match(/(?:open|zoom)\/(\d+)/);
    if(index<0&&matched)index=this.images.findIndex(image=>image.index===Number(matched[1]));
    if(index<0){
     const image=container.querySelector('img');
     if(image){try{const path=new URL(image.currentSrc||image.src,location.href).pathname;index=this.images.findIndex(item=>new URL(item.src,location.href).pathname===path);}catch{}}
    }
    if(index<0)return;
    event.preventDefault();event.stopImmediatePropagation();this.open(index,container.querySelector('img')?.currentSrc||container.querySelector('img')?.src);
   },{capture:true,signal});
   this.dialog.addEventListener('pointerdown',()=>{this.dialog.dataset.keyboard='false';},{capture:true,signal});
   this.dialog.addEventListener('keydown',event=>{
    if(event.key==='Tab')this.dialog.dataset.keyboard='true';
    if(['+','=','-','0','ArrowLeft','ArrowRight'].includes(event.key)){
     event.preventDefault();
     if(event.key==='+'||event.key==='=')this.zoom(this.scale+.5);
     else if(event.key==='-')this.zoom(this.scale-.5);
     else if(event.key==='0')this.reset();
     else this.select(this.index+(event.key==='ArrowLeft'?-1:1));
    }
   },{signal});
   this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.close();},{signal});
   this.dialog.addEventListener('click',event=>{
    const button=event.target.closest('[data-vzoom-action],[data-vzoom-index]');
    if(button){
     if(button.dataset.vzoomIndex!==undefined)this.select(Number(button.dataset.vzoomIndex));
     else{const action=button.dataset.vzoomAction;if(action==='close')this.close();else if(action==='in')this.zoom(this.scale+.5);else if(action==='out')this.zoom(this.scale-.5);else if(action==='reset')this.reset();else this.select(this.index+(action==='next'?1:-1));}
     return;
    }
    if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.close();}
   },{signal});
   this.stage.addEventListener('dblclick',event=>{event.preventDefault();this.zoom(this.scale>1?1:2,event.clientX,event.clientY);},{signal});
   this.stage.addEventListener('wheel',event=>{event.preventDefault();this.zoom(this.scale+(event.deltaY<0?.25:-.25),event.clientX,event.clientY);},{passive:false,signal});
   this.stage.addEventListener('pointerdown',event=>{
    if(event.button!==0&&event.pointerType==='mouse')return;
    event.preventDefault();this.stage.focus({preventScroll:true});this.stage.setPointerCapture(event.pointerId);
    this.points.set(event.pointerId,{x:event.clientX,y:event.clientY});this.snapshot();this.stage.dataset.dragging='true';
   },{signal});
   this.stage.addEventListener('pointermove',event=>{
    if(!this.points.has(event.pointerId))return;
    this.points.set(event.pointerId,{x:event.clientX,y:event.clientY});const values=[...this.points.values()];
    if(values.length>=2){
     const distance=Math.hypot(values[0].x-values[1].x,values[0].y-values[1].y);
     const center={x:(values[0].x+values[1].x)/2,y:(values[0].y+values[1].y)/2};
     const next=Math.max(1,Math.min(4,this.gesture.scale*distance/Math.max(1,this.gesture.distance)));
     const r=this.stage.getBoundingClientRect();const ax=this.gesture.center.x-r.left-r.width/2,ay=this.gesture.center.y-r.top-r.height/2;
     const ratio=next/this.gesture.scale;this.x=ax-(ax-this.gesture.x)*ratio+center.x-this.gesture.center.x;this.y=ay-(ay-this.gesture.y)*ratio+center.y-this.gesture.center.y;this.scale=next;
    }else{this.x=this.gesture.x+values[0].x-this.gesture.center.x;this.y=this.gesture.y+values[0].y-this.gesture.center.y;}
    this.paint();
   },{signal});
   const release=event=>{this.points.delete(event.pointerId);this.snapshot();this.stage.dataset.dragging=String(this.points.size>0);};
   this.stage.addEventListener('pointerup',release,{signal});this.stage.addEventListener('pointercancel',release,{signal});this.stage.addEventListener('lostpointercapture',release,{signal});
   this.img.addEventListener('load',()=>this.paint(),{signal});
   this.img.addEventListener('error',()=>{this.img.alt='Görsel yüklenemedi. Başka bir görsel seçebilirsiniz.';},{signal});
   this.observer=new ResizeObserver(()=>this.paint());this.observer.observe(this.stage);
   this.querySelector('[data-vzoom-action="previous"]').hidden=this.images.length<2;this.querySelector('[data-vzoom-action="next"]').hidden=this.images.length<2;
   this.querySelector('.vzoom-thumbs').hidden=this.images.length<2;
  }
  snapshot(){const values=[...this.points.values()];if(!values.length)return;this.gesture={scale:this.scale,x:this.x,y:this.y,center:values.length>1?{x:(values[0].x+values[1].x)/2,y:(values[0].y+values[1].y)/2}:values[0],distance:values.length>1?Math.hypot(values[0].x-values[1].x,values[0].y-values[1].y):1};}
  open(index,preview){this.previousFocus=document.activeElement;this.dialog.dataset.keyboard='false';this.select(index,preview);if(!this.dialog.open)this.dialog.showModal();this.dialog.focus({preventScroll:true});this.reset();}
  close(){this.selectionToken=(this.selectionToken||0)+1;this.dialog.close();this.points.clear();this.reset();if(this.previousFocus?.isConnected)this.previousFocus.focus({preventScroll:true});}
  select(index,preview){this.index=(index+this.images.length)%this.images.length;const image=this.images[this.index];
   const token=this.selectionToken=(this.selectionToken||0)+1;
   this.img.alt=image.alt||'Ürün görseli';this.img.width=image.width||1600;this.img.height=image.height||1600;
   this.img.src=preview||image.preview||image.src;
   const high=new Image();high.decoding='async';high.src=image.src;
   const ready=()=>{if(this.selectionToken===token&&this.isConnected)this.img.src=image.src;};
   if(typeof high.decode==='function')high.decode().then(ready).catch(()=>{});else high.onload=ready;
   this.reset();this.querySelector('.vzoom-count').textContent=(this.index+1)+' / '+this.images.length;this.querySelectorAll('[data-vzoom-index]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.vzoomIndex)===this.index)));const thumb=this.querySelector('[data-vzoom-index="'+this.index+'"]');if(thumb){const rail=thumb.parentElement;rail.scrollLeft=Math.max(0,thumb.offsetLeft-rail.offsetLeft-rail.clientWidth/2+thumb.offsetWidth/2);}}
  zoom(value,clientX,clientY){const next=Math.max(1,Math.min(4,value)),r=this.stage.getBoundingClientRect(),ax=clientX===undefined?0:clientX-r.left-r.width/2,ay=clientY===undefined?0:clientY-r.top-r.height/2;const ratio=next/this.scale;this.x=ax-(ax-this.x)*ratio;this.y=ay-(ay-this.y)*ratio;this.scale=next;this.paint();}
  reset(){this.scale=1;this.x=0;this.y=0;this.paint();}
  paint(){
   if(!this.stage||!this.img)return;
   const w=this.stage.clientWidth,h=this.stage.clientHeight,record=this.images?.[this.index];
   const nw=record?.width||this.img.naturalWidth||1600,nh=record?.height||this.img.naturalHeight||1600;
   if(w>0&&h>0){
    const fit=Math.min(Math.max(1,w-20)/nw,Math.max(1,h-20)/nh);
    const fittedWidth=nw*fit,fittedHeight=nh*fit;
    this.img.style.setProperty('--vz-width',fittedWidth+'px');this.img.style.setProperty('--vz-height',fittedHeight+'px');
    const maxX=Math.max(0,(fittedWidth*this.scale-w)/2),maxY=Math.max(0,(fittedHeight*this.scale-h)/2);
    this.x=Math.max(-maxX,Math.min(maxX,this.x));this.y=Math.max(-maxY,Math.min(maxY,this.y));
   }
   if(this.scale===1){this.x=0;this.y=0;}
   this.img.style.setProperty('--vz-scale',this.scale);this.img.style.setProperty('--vz-x',this.x+'px');this.img.style.setProperty('--vz-y',this.y+'px');
   this.stage.dataset.zoomed=String(this.scale>1);
   this.querySelector('.vzoom-percent').textContent=Math.round(this.scale*100)+'%';
   this.querySelector('[data-vzoom-action="out"]').disabled=this.scale<=1;this.querySelector('[data-vzoom-action="in"]').disabled=this.scale>=4;
  }

  disconnectedCallback(){this.selectionToken=(this.selectionToken||0)+1;if(this.dialog?.open)this.dialog.close();this.controller?.abort();this.observer?.disconnect();}
 });
}

if(!customElements.get('veira-media-layout')){
 customElements.define('veira-media-layout',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
   this.addEventListener('click',event=>{
    const dialog=event.target.closest('.dialog-zoomed-gallery__dialog');
    if(!dialog||event.target!==dialog)return;
    const r=dialog.getBoundingClientRect();
    if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.closest('zoom-dialog')?.close();
   },{signal});
   this.addEventListener('scroll',event=>{
    if(event.target.classList?.contains('dialog-zoomed-gallery'))event.target.closest('zoom-dialog')?.handleScroll?.();
   },{capture:true,passive:true,signal});
   if(this.dataset.leftThumbnails!=='true')return;
   const rail=this.querySelector('.veira-desktop-thumbs');if(!rail)return;
   const host=this.querySelector('.veira-gallery-host');
   const buttons=[...rail.querySelectorAll('[data-desktop-media-index]')];
   const desktop=matchMedia('(min-width:750px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
   const slideshow=()=>host.querySelector('media-gallery > slideshow-component');
   const sync=index=>{
    buttons.forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.desktopMediaIndex)===index)));
    const selected=buttons.find(button=>Number(button.dataset.desktopMediaIndex)===index);
    if(selected&&desktop.matches&&this.dataset.thumbnailPosition!=='left'){const left=selected.offsetLeft-rail.offsetLeft;const right=left+selected.offsetWidth;if(left<rail.scrollLeft)rail.scrollTo({left,behavior:reduced.matches?'auto':'smooth'});else if(right>rail.scrollLeft+rail.clientWidth)rail.scrollTo({left:right-rail.clientWidth,behavior:reduced.matches?'auto':'smooth'});}else if(selected&&desktop.matches){const top=selected.offsetTop-rail.offsetTop;const bottom=top+selected.offsetHeight;if(top<rail.scrollTop)rail.scrollTo({top,behavior:reduced.matches?'auto':'smooth'});else if(bottom>rail.scrollTop+rail.clientHeight)rail.scrollTo({top:bottom-rail.clientHeight,behavior:reduced.matches?'auto':'smooth'});}
   };
   rail.addEventListener('click',async event=>{
    const button=event.target.closest('[data-desktop-media-index]');if(!button||!desktop.matches)return;
    await customElements.whenDefined('slideshow-component');if(signal.aborted)return;
    const gallery=slideshow();if(typeof gallery?.select!=='function')return;
    const index=Number(button.dataset.desktopMediaIndex);gallery.select(index,event,{animate:!reduced.matches});sync(index);
   },{signal});
   host.addEventListener('slideshow:select',event=>{if(event.target===slideshow()&&Number.isFinite(event.detail?.index))sync(event.detail.index);},{signal});
   const resize=()=>{
    if(!desktop.matches||this.dataset.thumbnailPosition!=='left'){rail.style.removeProperty('max-height');return;}
    const gallery=slideshow(),height=gallery?.getBoundingClientRect().height;
    if(height>0)rail.style.maxHeight=Math.round(height)+'px';
   };
   this.observer=new ResizeObserver(resize);this.observer.observe(host);
   desktop.addEventListener('change',resize,{signal});
   customElements.whenDefined('slideshow-component').then(()=>{if(signal.aborted)return;sync(Number(slideshow()?.current)||0);resize();});
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["renk-secenekler-2"] && !Shopify.designMode) return;
  try {
    (() => {
 const prepared=new Set(),images=new Map();
 function init(root){
  if(root.dataset.color2PrefetchReady||root.dataset.prefetch!=='true'||root.dataset.designMode==='true')return;
  root.dataset.color2PrefetchReady='true';
  const connection=navigator.connection;
  if(connection?.saveData||/^(slow-)?2g$/.test(connection?.effectiveType||''))return;
  const controller=new AbortController(),signal=controller.signal;
  let visibility,idle=0;
  function prepare(link){
   let url;try{url=new URL(link.href,location.href);}catch{return;}
   if(url.origin!==location.origin||url.pathname===location.pathname||prepared.has(url.href))return;
   prepared.add(url.href);
   if(HTMLScriptElement.supports?.('speculationrules')){
    const rules=document.createElement('script');rules.type='speculationrules';
    rules.textContent=JSON.stringify({prefetch:[{source:'list',urls:[url.href]}]});document.head.append(rules);
   }else{
    const hint=document.createElement('link');hint.rel='prefetch';hint.href=url.href;hint.as='document';
    if(hint.relList?.supports?.('prefetch'))document.head.append(hint);
    else fetch(url.href,{credentials:'same-origin',priority:'low',signal}).catch(()=>{});
   }
   const imageURL=link.dataset.productImage;
   if(imageURL&&!images.has(imageURL)){
    const image=new Image();image.decoding='async';image.fetchPriority='low';image.src=imageURL;images.set(imageURL,image);
   }
  }
  const prepareAll=()=>root.querySelectorAll('[data-color2-destination]').forEach(prepare);
  root.addEventListener('pointerover',e=>{const link=e.target.closest('[data-color2-destination]');if(link)prepare(link);},{passive:true,signal});
  root.addEventListener('focusin',e=>{const link=e.target.closest('[data-color2-destination]');if(link)prepare(link);},{signal});
  root.addEventListener('pointerdown',e=>{const link=e.target.closest('[data-color2-destination]');if(link)prepare(link);},{passive:true,signal});
  visibility=new IntersectionObserver(entries=>{
   if(!entries.some(e=>e.isIntersecting))return;visibility.disconnect();
   if('requestIdleCallback' in window)idle=requestIdleCallback(prepareAll,{timeout:1500});else idle=setTimeout(prepareAll,250);
  },{rootMargin:'150px'});visibility.observe(root);
  root.veiraColor2Cleanup=()=>{controller.abort();visibility.disconnect();if('cancelIdleCallback' in window)cancelIdleCallback(idle);else clearTimeout(idle);};
 }
 const scan=scope=>scope.querySelectorAll('[data-veira-color2-links]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
 document.addEventListener('shopify:section:load',e=>scan(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-veira-color2-links]').forEach(root=>root.veiraColor2Cleanup?.()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["renk-secenekleri"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('veira-color-groups')){
 customElements.define('veira-color-groups',class extends HTMLElement{
  connectedCallback(){
   this.observer?.disconnect();
   const update=()=>{
    cancelAnimationFrame(this.frame);
    this.frame=requestAnimationFrame(()=>{
     const groups=[...this.children].filter(el=>el.classList.contains('veira-colors'));
     if(this.dataset.inline!=='true'||groups.length!==2){this.classList.remove('is-inline');return;}
     const gap=Math.max(12,parseFloat(getComputedStyle(this).getPropertyValue('--vc-group-gap'))||0);
     const width=groups.reduce((sum,group)=>{
      const options=group.querySelector('.veira-colors__options');
      const items=[...options.children];
      const itemGap=parseFloat(getComputedStyle(options).columnGap)||0;
      const optionsWidth=items.reduce((total,item)=>total+item.getBoundingClientRect().width,0)+Math.max(0,items.length-1)*itemGap;
      const heading=group.querySelector('.veira-colors__heading');
      const range=document.createRange();range.selectNodeContents(heading);
      const headingWidth=range.getBoundingClientRect().width;
      return sum+Math.max(optionsWidth,headingWidth);
     },0)+gap*2+1;
     this.classList.toggle('is-inline',width<=this.clientWidth-2);
    });
   };
   this.observer=new ResizeObserver(update);this.observer.observe(this);update();
   document.fonts?.ready.then(()=>{if(this.isConnected)update();});
  }
  disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);}
 });
}

(() => {
 const prepared=new Set(),images=new Map();
 function init(root){
  if(root.dataset.colorPrefetchReady||root.dataset.prefetch!=='true'||root.dataset.designMode==='true')return;
  root.dataset.colorPrefetchReady='true';
  const connection=navigator.connection;
  if(connection?.saveData||/^(slow-)?2g$/.test(connection?.effectiveType||''))return;
  const controller=new AbortController(),signal=controller.signal;
  let visibility,idle=0;
  function prepare(link){
   let url;try{url=new URL(link.href,location.href);}catch{return;}
   if(url.origin!==location.origin||url.pathname===location.pathname||prepared.has(url.href))return;
   prepared.add(url.href);
   if(HTMLScriptElement.supports?.('speculationrules')){
    const rules=document.createElement('script');rules.type='speculationrules';
    rules.textContent=JSON.stringify({prefetch:[{source:'list',urls:[url.href]}]});document.head.append(rules);
   }else{
    const hint=document.createElement('link');hint.rel='prefetch';hint.href=url.href;hint.as='document';
    if(hint.relList?.supports?.('prefetch'))document.head.append(hint);
    else fetch(url.href,{credentials:'same-origin',priority:'low',signal}).catch(()=>{});
   }
   const imageURL=link.dataset.productImage;
   if(imageURL&&!images.has(imageURL)){
    const image=new Image();image.decoding='async';image.fetchPriority='low';image.src=imageURL;images.set(imageURL,image);
   }
  }
  const prepareAll=()=>root.querySelectorAll('[data-color-destination]').forEach(prepare);
  root.addEventListener('pointerover',e=>{const link=e.target.closest('[data-color-destination]');if(link)prepare(link);},{passive:true,signal});
  root.addEventListener('focusin',e=>{const link=e.target.closest('[data-color-destination]');if(link)prepare(link);},{signal});
  root.addEventListener('pointerdown',e=>{const link=e.target.closest('[data-color-destination]');if(link)prepare(link);},{passive:true,signal});
  visibility=new IntersectionObserver(entries=>{
   if(!entries.some(e=>e.isIntersecting))return;visibility.disconnect();
   if('requestIdleCallback' in window)idle=requestIdleCallback(prepareAll,{timeout:1500});else idle=setTimeout(prepareAll,250);
  },{rootMargin:'150px'});visibility.observe(root);
  root.veiraColorCleanup=()=>{controller.abort();visibility.disconnect();if('cancelIdleCallback' in window)cancelIdleCallback(idle);else clearTimeout(idle);};
 }
 const scan=scope=>scope.querySelectorAll('[data-veira-color-links]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
 document.addEventListener('shopify:section:load',e=>scan(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-veira-color-links]').forEach(root=>root.veiraColorCleanup?.()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["veira-buy-buttons"] && !Shopify.designMode) return;
  try {
    class VeiraPurchaseControls extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.onBuy = event => {
        if (!event.target.closest?.('[data-vb-buy-now]')) return;
        event.preventDefault();event.stopImmediatePropagation();
        const form = this.buy.closest('form');
        const add = form?.querySelector('.add-to-cart-button');
        const variant = form?.querySelector('[name="id"]');
        if (this.submitting || !form || !variant?.value || variant.disabled || !add || add.disabled) return;
        if (!form.checkValidity()) { form.reportValidity();return; }
        const target = new URL(this.dataset.checkoutUrl, location.origin);
        if (target.origin !== location.origin) return;
        let redirect = form.querySelector('input[name="return_to"]');
        this.redirectState = { element: redirect, value: redirect?.value, created: !redirect };
        if (!redirect) { redirect = document.createElement('input');redirect.type = 'hidden';redirect.name = 'return_to';form.append(redirect);this.redirectState.element = redirect; }
        redirect.value = target.pathname + target.search;
        this.submitting = true;this.checkoutAdd = add;this.checkoutPreviousDisabled = add.disabled;
        add.disabled = true;this.buy.disabled = true;this.buy.setAttribute('aria-busy', 'true');
        try { HTMLFormElement.prototype.submit.call(form); }
        catch (error) {
          this.resetCheckout();
          let message = this.querySelector('[data-vb-error]');
          if (!message) { message = document.createElement('p');message.dataset.vbError = '';message.setAttribute('role', 'alert');this.append(message); }
          message.textContent = 'Ödeme sayfası açılamadı. Tekrar dene.';
        }
      };
      this.addEventListener('click', this.onBuy, { capture: true, signal: this.controller.signal });
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });
      window.addEventListener('pageshow', () => {
        this.resetCheckout();this.schedule();
      }, { signal: this.controller.signal });
      this.mount();
    }
    disconnectedCallback() {
      this.controller?.abort();this.controller = null;this.observer?.disconnect();cancelAnimationFrame(this.frame);this.frame = null;
    }
    resetCheckout() {
      this.submitting = false;
      this.buy?.removeAttribute('aria-busy');
      if (this.checkoutAdd?.isConnected) this.checkoutAdd.disabled = this.checkoutPreviousDisabled;
      this.checkoutAdd = null;
      if (this.redirectState?.element) {
        if (this.redirectState.created) this.redirectState.element.remove();
        else this.redirectState.element.value = this.redirectState.value;
      }
      this.redirectState = null;
    }
    schedule() {
      if (this.frame != null) return;
      this.frame = requestAnimationFrame(() => { this.frame = null;if (this.isConnected) this.mount(); });
    }
    mount() {
      const form = this.querySelector('product-form-component form');
      const controls = form?.querySelector('.product-form-buttons');
      const template = this.querySelector('[data-vb-buy-template]');
      if (!controls || !template) return;
      if (!this.buy) this.buy = template.content.firstElementChild.cloneNode(true);
      if (this.buy.parentElement !== controls) controls.append(this.buy);
      const add = form.querySelector('.add-to-cart-button');
      const variant = form.querySelector('[name="id"]');
      const disabled = this.submitting || !add || add.disabled || !variant?.value || variant.disabled;
      if (this.buy.disabled !== disabled) this.buy.disabled = disabled;
      if (!disabled && this.dataset.addLabel) {
        const label = [...add.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (label && label.textContent.trim() !== this.dataset.addLabel) label.textContent = this.dataset.addLabel;
      }
    }
  }
  if (!customElements.get('veira-purchase-controls')) customElements.define('veira-purchase-controls', VeiraPurchaseControls);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["veira-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veira-size-guide')) {
  customElements.define('veira-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-guide-open]');
      if (!dialog || !trigger) return;
      const tabs = [...this.querySelectorAll('[data-guide-tab]')];
      const panels = [...this.querySelectorAll('[data-guide-panel]')];
      const activate = (tab, focus = false) => {
        if (!tab || !tabs.includes(tab)) return;
        for (const item of tabs) {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        }
        for (const panel of panels) panel.hidden = panel.dataset.guidePanel !== tab.dataset.guideTab;
        if (focus) tab.focus({preventScroll:true});
        if (dialog.open) tab.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
        const body = this.querySelector('.vsg__body');
        if (body) body.scrollTop = 0;
      };
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        activate(tabs.find(tab => tab.dataset.guideTab === this.dataset.defaultCategory) || tabs[0]);
        dialog.showModal();
      }, {signal});
      this.querySelector('[data-guide-close]')?.addEventListener('click', () => dialog.close(), {signal});
      for (const tab of tabs) {
        tab.addEventListener('click', () => activate(tab), {signal});
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const index = tabs.indexOf(tab);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activate(tabs[next], true);
        }, {signal});
      }
      let backdropDown = false;
      const outside = event => {
        const box = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
      };
      dialog.addEventListener('pointerdown', event => { backdropDown = outside(event); }, {signal});
      dialog.addEventListener('click', event => {
        if (backdropDown && outside(event)) dialog.close();
        backdropDown = false;
      }, {signal});
      dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus({preventScroll:true}); }, {signal});
      // Keep the old data-guide-open trigger and native Escape/focus behavior intact.
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
